import { useContext } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import optimizeImage, { Options } from '~/utilities/optimizeImage';

export default function useVehicleImageUrl(opts: Options): string {
  const { customizeOptions, trims, truckBodyStyles } =
    useContext(ParentModelContext);
  const customizedTrim = customizeOptions.data;

  const baseTrim =
    trims.data.results.find(trim => trim.priceAdd === 0) ??
    trims.data.results.at(0);
  const truckBodyStyleData = truckBodyStyles.data;

  return optimizeImage(
    customizedTrim.imageUrl ||
      truckBodyStyleData.imageUrl ||
      baseTrim?.imageUrl ||
      '',
    opts
  );
}
